import { render, staticRenderFns } from "./SearchFrom_past.vue?vue&type=template&id=27087a14&"
import script from "./SearchFrom_past.vue?vue&type=script&lang=js&"
export * from "./SearchFrom_past.vue?vue&type=script&lang=js&"
import style0 from "./SearchFrom_past.vue?vue&type=style&index=0&id=27087a14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports